import { useOverlays } from "contexts/OverlayContext";
import { TransactionSplitModal } from "./TransactionSplitModal";

export const TransactionSplitModalContainer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo<"transactionSplit">("transactionSplit");

    if (!overlayInfo || !overlayInfo.data) {
        return null;
    }

    return (
        <TransactionSplitModal
            transaction={overlayInfo.data.transaction}
            closeModal={closeOverlay}
            open={!overlayIsClosing}
            onSplitSave={overlayInfo.data.onSplitSave}
        />
    );
};
